import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { s as state } from './index3.js';
import { C as CURRENT_MODULE } from './index2.js';
import { d as defineCustomElement$1 } from './button-base2.js';

import { baseCss } from './css.js';
const nlLoadingCss = baseCss;

const NlLoadingStyle0 = nlLoadingCss;

const NlLoading = /*@__PURE__*/ proxyCustomElement(class NlLoading extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.stopFetchHandler = createEvent(this, "stopFetchHandler", 7);
        this.handleContinue = createEvent(this, "handleContinue", 7);
        this.path = undefined;
    }
    handleStop(e) {
        e.preventDefault();
        this.stopFetchHandler.emit();
    }
    handleContinueClick(e) {
        e.preventDefault();
        // reset();
        this.handleContinue.emit();
    }
    render() {
        let title = 'Connecting...';
        let text = 'Establishing connection to your key storage.';
        if (state.njumpIframe) {
            title = '';
            text = '';
        }
        else if (this.path === CURRENT_MODULE.LOCAL_SIGNUP) {
            title = 'Creating...';
            text = 'Publishing your profile on Nostr.';
        }
        else if (state.authUrl) {
            if (state.isLoading) {
                title = 'Confirming...';
                text = 'Please confirm the connection in your key storage app.';
            }
            else {
                title = 'Almost ready!';
                text = 'Continue to confirm the connection to your key storage.';
            }
        }
        const showButton = this.path !== CURRENT_MODULE.LOCAL_SIGNUP;
        const showIframe = !state.isLoading && state.iframeUrl && state.authUrl;
        const iframeUrl = state.iframeUrl ? `${state.iframeUrl}?connect=${encodeURIComponent(state.authUrl)}` : '';
        return (h("div", { key: 'ff7ae663f31e7c0e10a0f10d45314519f08d5199', class: "p-4 overflow-y-auto" }, title && (h("h1", { key: '86c13915dd489fd9182263edd47835cbe6c0c24a', class: "nl-title font-bold text-center text-4xl" }, title)), text && (h("p", { key: '23b2cc3700b833e0c4575c4b5833dce77b51af78', class: "nl-description font-light text-center text-lg pt-2 max-w-96 mx-auto" }, text)), !state.njumpIframe && !state.authUrl && state.isLoading && (h("div", { key: '8f7da53775a410de55c26a706d70a5954ff3231c', class: "mt-10 mb-10 ml-auto mr-auto w-20" }, h("span", { key: '15e94a6bf7a0a4471e2d4e6bd0bce5eb5cd3dc0a', slot: "icon-start", class: "animate-spin-loading ml-auto mr-auto inline-block w-20 h-20 border-[4px] border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full", role: "status", "aria-label": "loading" }))), h("div", { key: 'c32c535e64608e4d7bc11df9d0ee5360604ec9ea', class: "ps-4 pe-4 overflow-y-auto" }, h("p", { key: '73e123470d5d0466a2690cd9ba947663e550afda', class: "nl-error font-light text-center text-sm max-w-96 mx-auto" }, state.error)), iframeUrl && (h("div", { key: 'e6778c319037c8621aff5d34d1d2b3f0cbfc1c1e', class: "mt-3 ml-auto mr-auto w-72 flex justify-center" }, h("iframe", { key: 'd202f154ef014e96eae19e3f97432113a71127d4', src: iframeUrl, width: "180px", height: "80px", style: { display: showIframe ? 'block' : 'none', border: '0' } }))), state.njumpIframe && (h("div", { key: '8fdc700c3983574930b14ea04448fb8123dfb83a', class: "mt-3 ml-auto mr-auto flex justify-center" }, h("iframe", { key: 'eafaf5df4a3ecbfba3d191c3e1b1c63181bdb41b', srcdoc: state.njumpIframe, width: "600px", style: { border: '0', height: "80vh", borderRadius: "8px" } }))), !showIframe && showButton && (h("div", { key: '1557f1de773239d199e10249c45bc3684dee1773', class: "mt-3 ml-auto mr-auto w-72" }, h("button-base", { key: '1f33346f69d5b2a670f0e507e48855376b82e679', onClick: e => {
                if (state.authUrl && !state.isLoading) {
                    this.handleContinueClick(e);
                }
                else {
                    this.handleStop(e);
                }
            }, titleBtn: !state.isLoading ? 'Continue' : 'Cancel' })))));
    }
    static get style() { return NlLoadingStyle0; }
}, [0, "nl-loading", {
        "path": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-loading", "button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-loading":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlLoading);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlLoading as N, defineCustomElement as d };

//# sourceMappingURL=nl-loading2.js.map